import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCandidate } from "../../../../redux/actions/admin/CandidateActions";
import localStorageService from "../../../../services/localStorageService";
import { CircularProgress } from "@material-ui/core";
import jsPDF from "jspdf";

const ResumeTemplate4 = ({ storeCandidate, getCandidate }) => {
  const [candidateId, setCandidateId] = useState("");
  const [candidate, setCandidate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [initials, setInitials] = useState("");

  useEffect(() => {
    const candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) setCandidateId(candidate.id);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!candidateId) return;

    const fetchCandidate = async () => {
      setIsLoading(true);
      const candidateData =
        storeCandidate.candidate || (await getCandidate(candidateId));
      setCandidate(candidateData);
      setIsLoading(false);

      if (candidateData?.firstName && candidateData?.lastName) {
        setInitials(
          `${candidateData.firstName.charAt(0)}/${candidateData.lastName.charAt(
            0
          )}`
        );
      }
    };

    fetchCandidate();
  }, [candidateId]);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.html(document.querySelector(".cv-container"), {
      callback: (doc) => doc.save("resume.pdf"),
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du cv en cours...</div>
        </div>
      ) : (
        <>
          <div className="cv-container">
            <style>
              {`
            body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
                background-color: #f0f0f0;
            }

            .resume {
                display: flex;
                max-width: 900px;
                margin: 20px auto;
                background-color: white;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            }

            .left {
                width: 35%;
                padding: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                color: white;
                background: linear-gradient(to bottom, #007CB5 0%, #007CB5 50%, #1f1f1f 50%, #1f1f1f 100%);
                overflow: hidden;
            }

            .profile-pic {                
                background-color: grey;
                border-radius: 50%;
                margin-bottom: 20px;
                border: 5px solid white;
                z-index: 2;
                width: 220px;
                height: 220px;
                -webkit-border-radius: 50%;
                -moz-border-radius: 50%;
                border-radius: 50%;
                background-repeat: no-repeat;
                -webkit-background-size: cover;
                -moz-background-size: cover;
                background-size: cover;
                overflow: hidden;
            }
            .contact, .profile {
                text-align: left;
                margin-bottom: 20px;
                z-index: 2;
            }
            .contact h2, .profile h2 {
                border-bottom: 2px solid #007CB5;
                padding-bottom: 5px;
                margin-bottom: 10px;
            }
            .profile h2 {
                color: #fff !important;
            }
            .left .contact {
                position: absolute;
                top: 250px;
                left: 20px;
            }
            .left .profile {
                position: absolute;
                bottom: 20px;
                left: 20px;
                width: calc(100% - 40px);
            }
            .left::before {
                content: '';
                position: absolute;
                top: -20%;
                left: -20%;
                width: 140%;
                height: 140%;
                background: radial-gradient(circle at 50% 50%, #007CB5, #1f1f1f);
                transform: rotate(45deg);
                clip-path: ellipse(40% 25% at 50% 50%);
                z-index: 1;
            }
            .right {
                width: 65%;
                padding: 20px;
                position: relative;
            }
            .right::before {
                content: '';
                position: absolute;
                left: -20px;
                top: 0;
                width: 20px;
                height: 100%;
                background-color: #007CB5;
                border-radius: 10px 0 0 10px;
            }
            .right h1 {
                margin: 0;
                font-size: 2.5em;
                color: #333;
            }

            .right h2 {
                margin: 0;
                font-size: 1.5em;
                color: #007CB5;
            }

            section {
                margin-top: 20px;
            }

            section h3 {
                color: #007CB5;
                border-bottom: 2px solid #007CB5;
                padding-bottom: 5px;
                margin-bottom: 10px;
            }

            section div {
                margin-bottom: 20px;
            }

            section h4 {
                margin: 0;
                color: #333;
            }

            section p {
                margin: 5px 0 0 0;
                color: #666;
            }

            /* Icon Styles */
            .contact p i, section h3 i {
                margin-right: 10px;
            }
            .button-container {
                position: fixed;
                right: 20px;
                top: 50%;
                transform: translateY(-50%);
                display: flex;
                flex-direction: column;
                gap: 10px;
            }

            .btn {
                padding: 12px 20px;
                font-size: 16px;
                cursor: pointer;
                border: none;
                border-radius: 5px;
                color: #fff;
                background-color: #333;
            }

            .btn-download {
                background-color: #5cb85c;
            }
                /*bullet checklist by www.peeayecreative.com*/
            .pa-bullet-list-1 ul {
            list-style-type: none!important;
            }

            .pa-bullet-list-1 ul li:before {
            content: '\e052'!important;
            color: #2cba6c;
            font-family: 'ETMODULES'!important;
            margin-right: 10px;
            margin-left: -14px;
            font-size: 1.2em!important;
            }                    
            /* Media Queries for Print */
            @media print {
                body {
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }
                .resume {
                    box-shadow: none;
                    margin: 0;
                    width: 100%;
                }

                .left {
                    width: 30%;
                }

                .right {
                    width: 70%;
                }

                .right::before {
                    display: none;
                }
                .button-container, footer {
                    display: none;
                }
            }


        `}
            </style>

            <div className="resume">
              <div className="left">
                <div
                  className="profile-pic"
                  style={{
                    backgroundImage: `url(${candidate?.profilePictureUrl})`,
                  }}
                ></div>
                <div className="contact">
                  <h2>Contact</h2>
                  <p>
                    <i className="fas fa-phone"></i> {candidate?.phoneNumber1}
                  </p>
                  <p>
                    <i className="fas fa-envelope"></i> {candidate?.email}
                  </p>
                </div>
                <div className="profile">
                  <h2 className="heading heading_dark heading_skills">
                    Compétences
                  </h2>
                  <ul className="skills-list">
                    {candidate?.skills.map((skill, index) => (
                      <li className="skills-list__item">{skill.title}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="right">
                <h1>
                  {candidate?.firstName} {candidate?.lastName}
                </h1>
                <section>
                  <h3>
                    <i className="fas fa-user"></i> Sommaire
                  </h3>
                  <div
                    className="html-content summary-content"
                    dangerouslySetInnerHTML={{ __html: candidate?.summary }}
                  />
                </section>
                <section>
                  <h3>
                    <i className="fas fa-graduation-cap"></i> Parcours scolaire
                  </h3>
                  <ul className="list">
                    {candidate?.educations.map((edu, index) => (
                      <li className="list-item list-item_non-border">
                        <h4 className="list-item__title">{edu.degree}</h4>
                        <span className="list-item__date">
                          {edu.institute}, {edu.startYear} - {edu.endYear}
                        </span>
                        <p className="list-item__text">{edu?.description}</p>
                      </li>
                    ))}
                  </ul>
                </section>
                <section>
                  <h3>
                    <i className="fas fa-briefcase"></i> Expérience
                    Professionnelle
                  </h3>

                  <ul className="list">
                    {candidate?.workExperiences.map((job, index) => (
                      <li className="list-item">
                        <h4 className="list-item__title">
                          {job.title} - {job.companyName}
                        </h4>
                        <span className="list-item__date">
                          {new Date(job.startDate).toLocaleDateString()} -{" "}
                          {new Date(job.endDate).toLocaleDateString()}
                        </span>
                        <p className="list-item__text">{job?.description}</p>
                      </li>
                    ))}
                  </ul>
                </section>
                <section>
                  <h3>
                    <i className="fas fa-language"></i> Langues
                  </h3>
                  <ul className="pa-bullet-list-1">
                    {candidate?.languages.map((language, index) => (
                      <li>{language.name}</li>
                    ))}
                  </ul>
                </section>
              </div>
            </div>

            <div className="button-container">
              <button className="btn btn-print" onClick={() => window.print()}>
                Imprimer mon CV
              </button>
              <button className="btn btn-download" onClick={downloadPDF}>
                Télécharger le PDF
              </button>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

ResumeTemplate4.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
});

export default connect(mapStateToProps, { getCandidate })(ResumeTemplate4);
